module.exports = "<div class=\"appraisal-container\">\r\n  <input type=\"button\" class=\"btn btn-warning\" value=\"Reset\" ng-click=\"$ctrl.reset()\"/>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/components/vehicle/vehicleAppraisal/bodywork/bodywork.html
// module id = 1151
// module chunks = 0